import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchLanguages'
})

export class SearchLanguagesPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'LANGUAGE') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['languages']) {
          return (
            eachItem['fields']['languages'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}